import { useEffect, useState } from "react";
import { X } from "lucide-react";

import { callApi, formatDT } from "./utils";

export default function CommentsHistory({ apiPath, apiQueryParams, onCancel }) {
  const [comments, setComments] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    setError("");

    const queryParams = apiQueryParams
      ? new URLSearchParams(apiQueryParams)
      : null;

    callApi({
      method: "GET",
      path: apiPath,
      needAuth: true,
      queryParams,
    })
      .then((response) => {
        setIsLoading(false);

        const err = response.error;
        if (err) {
          setError(response.message || "Не удалось загрузить историю.");
        } else {
          const respArr = response.response;
          if (respArr) {
            setComments(respArr);
          }
        }
      })
      .catch(() => setIsLoading(false));
  }, []);

  const renderBody = () => {
    if (isLoading) {
      return <p className="muted">Загрузка истории...</p>;
    }

    if (error) {
      return <p className="warning">{error}</p>;
    }

    if (!comments.length) {
      return <p className="muted">Комментариев пока нет.</p>;
    }

    return (
      <div className="comments-timeline">
        {comments.map((comment) => (
          <article className="comment-entry" key={comment.id}>
            <div className="comment-entry-marker" aria-hidden="true" />
            <div className="comment-entry-content">
              <div className="comment-entry-meta">
                <time dateTime={comment.createdAt}>
                  {formatDT(comment.createdAt)}
                </time>
                <strong>
                  {comment.authorName || "Преподаватель не указан"}
                </strong>
              </div>
              <div className="comment-entry-status">
                {comment.statusName || comment.statusCode || "Статус не указан"}
              </div>
              <div className="comment-entry-versions">
                {comment.versionsLabel || "Вложения отсутствуют"}
              </div>
              <p className="comment-entry-text">{comment.text}</p>
            </div>
          </article>
        ))}
      </div>
    );
  };

  return (
    <div className="modal-backdrop" role="dialog" aria-modal="true">
      <div className="modal comments-history-modal">
        <div className="modal-head">
          <h2>Комментарии</h2>
          <button className="icon-btn" onClick={onCancel} aria-label="Закрыть">
            <X size={18} />
          </button>
        </div>

        <div className="modal-body">{renderBody()}</div>

        <div className="modal-foot">
          <button className="btn ghost" onClick={onCancel}>
            Закрыть
          </button>
        </div>
      </div>
    </div>
  );
}
